import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value:{},
  containerValue:[],
};

export const h2Slice = createSlice({
  name: "H2Redux",
  initialState,
  reducers: {
    updateValue: (state, action) => {
      state.value = action.payload;
    },
    updateContainer: (state, action) => {
      state.containerValue = action.payload;
    }
  },
});


export const { updateValue, updateContainer } = h2Slice.actions;

export default h2Slice.reducer;
